import React from "react";
import DOMPurify from 'dompurify';

import styles from "./Message.module.css";
import clsx from "clsx";
import { messageTypes } from "../BeverageConstants";

export const Message = (props) => {
  const { isBot, messageType, message, imageSrc, additionalClasses = [] } = props;

  switch (messageType) {
    case messageTypes.Image:
      return <div data-testid={isBot ? "beverage-bot-message" : "beverage-user-message"} className={clsx(styles.imageMessage, isBot ? styles.botMessage : styles.userMessage)}>
        <img data-testid="beverage-chat-image" src={imageSrc}/>
      </div>;
    default:
      return (
        <div data-testid={isBot ? "beverage-bot-message" : "beverage-user-message"} className={clsx(styles.message, isBot ? styles.botMessage : styles.userMessage, ...additionalClasses) }
             dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message, { USE_PROFILES: { html: true } })}}>
        </div>
      );
  }


}